export default __webpack_public_path__ + "static/Live-Video_F-Secure-1de8fcd33a37c1b7109a2d0333d15efe.webp";